var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDataLoaded)?_c('div',{staticClass:"p-4 bg-white rounded-lg h-100"},[_c('DataTable',{attrs:{"table_state":_vm.table_state,"store_names":_vm.store_names,"addComponent":_vm.componentForAdding,"editComponent":_vm.componentForEditing,"showDetailComponent":_vm.componentForDetails,"delete_url":_vm.delete_url,"urls":_vm.urls}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }